import React, { useContext, useEffect, useState, useCallback } from 'react';
import { Box, Typography, Menu, MenuItem } from '@mui/material';
import StoreRoundedIcon from '@mui/icons-material/StoreRounded';
import UnfoldMoreRoundedIcon from '@mui/icons-material/UnfoldMoreRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { isUndefined } from 'lodash';
import { DataContext } from '../../context/DataContext';
import { getToken } from '../../api/Account';
import { getSucursalByUserAsync } from '../../api/Users';

// Selector global de sucursal en el topbar — ver README.md (SucursalSelector).
// Sustituye a los selectores locales que cada pantalla implementaba por su cuenta.
const SucursalSelector = () => {
	const { selectedSucursal, setSelectedSucursal } = useContext(DataContext);
	const [sucursales, setSucursales] = useState([]);
	const [anchorEl, setAnchorEl] = useState(null);
	const token = getToken();

	const loadSucursales = useCallback(async () => {
		const result = await getSucursalByUserAsync(token);
		if (!result.statusResponse) {
			return;
		}
		const list = result.data.result || [];
		setSucursales(list);
		if ((selectedSucursal === 0 || isUndefined(selectedSucursal)) && list.length > 0) {
			setSelectedSucursal(list[0].id);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [token]);

	useEffect(() => {
		loadSucursales();
	}, [loadSucursales]);

	if (sucursales.length === 0) {
		return null;
	}

	const activa = sucursales.find((s) => s.id === selectedSucursal);

	return (
		<>
			<Box
				onClick={(e) => setAnchorEl(e.currentTarget)}
				sx={{
					display: 'flex',
					alignItems: 'center',
					gap: '10px',
					backgroundColor: 'background.paper',
					border: '1px solid',
					borderColor: 'divider',
					borderRadius: '10px',
					padding: '6px 11px',
					cursor: 'pointer',
					minWidth: 210,
					'&:hover': { borderColor: '#00a152' }
				}}
			>
				<Box
					sx={{
						width: 30,
						height: 30,
						borderRadius: '8px',
						backgroundColor: 'success.light',
						color: 'success.main',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						flexShrink: 0
					}}
				>
					<StoreRoundedIcon sx={{ fontSize: 18 }} />
				</Box>
				<Box sx={{ flex: 1, minWidth: 0, lineHeight: 1.15 }}>
					<Typography sx={{ fontSize: 10, color: 'text.disabled', fontWeight: 600, letterSpacing: '.4px', textTransform: 'uppercase' }}>
						Sucursal
					</Typography>
					<Typography
						sx={{
							fontSize: 13,
							fontWeight: 600,
							color: 'text.primary',
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis'
						}}
					>
						{activa ? activa.description : ''}
					</Typography>
				</Box>
				<UnfoldMoreRoundedIcon sx={{ fontSize: 20, color: 'text.disabled' }} />
			</Box>
			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={() => setAnchorEl(null)}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
				PaperProps={{ sx: { borderRadius: '11px', minWidth: 220, marginTop: '6px' } }}
			>
				{sucursales.map((s) => (
					<MenuItem
						key={s.id}
						selected={s.id === selectedSucursal}
						onClick={() => {
							setSelectedSucursal(s.id);
							setAnchorEl(null);
						}}
						sx={{ display: 'flex', gap: '9px', fontSize: 13, fontWeight: 500 }}
					>
						<StoreRoundedIcon sx={{ fontSize: 18, color: 'text.disabled' }} />
						<Box component="span" sx={{ flex: 1 }}>
							{s.description}
						</Box>
						{s.id === selectedSucursal ? <CheckRoundedIcon sx={{ fontSize: 18, color: 'success.main' }} /> : null}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};

export default SucursalSelector;
